import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Text from '@tamagoshi/core/Text';
import LockIcon from '@tamagoshi/icons/Lock';
import { withClient } from '@components';
import { PLATFORMS } from '@constants';
import { getTranslations } from '@translations';
import { TrustPilot, Awards, Payment, Partner } from './components';

import styles from './styles/index.module.scss';

const Quality = memo(({ platform, breakpoints }) => {
  const translations = getTranslations();

  return (
    <div className={styles.container}>
      <Text type="small" weight="semiBold" className={styles.title}>
        {translations('footer.quality.service.title')}
        <Text tag="span" type="small" className={styles.subHeading}>
          {translations('footer.quality.service.sub.title')}
        </Text>
      </Text>
      <div className={styles.block}>
        <LockIcon className={styles.lock} />
        <Text type="tiny" className={styles.subTitle}>
          {translations('footer.quality.payment.title')}
        </Text>
      </div>
      <TrustPilot platform={platform} />
      <Awards platform={platform} />
      <Partner platform={platform} />
      <Payment platform={platform} breakpoints={breakpoints} />
    </div>
  );
});

Quality.propTypes = {
  breakpoints: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  platform: PropTypes.oneOf(Object.values(PLATFORMS)).isRequired,
};

Quality.displayName = 'Quality';

export default withClient(Quality);
